import AOS from 'aos'
import 'aos/dist/aos.css'

window.addEventListener('load', () => {
  setTimeout(() => {
    AOS.init({
      disable: 'mobile',
      once: true,
      easing: 'ease-out-quart',
    })

    window.Aos = AOS
  }, 500)
})
